// extracted by mini-css-extract-plugin
module.exports = {"btnGroup":"styles_btnGroup__1wRZK"};